export enum BookingKitTableColumns {
  Week = "Week",
  Assigned = "Assigned",
  Consultant = "Consultant",
  Customer = "Customer",
  IsNationalProcurement = "IsNationalProcurement",
  Aoe = "Aoe",
  CostCenter = "CostCenter",
  Project = "Project",
  Alt = "Alt",
  KitStatus = "KitStatus",
  LastEvent = "LastEvent",
  ManagementStatus = "ManagementStatus",
  Type = "Type",
  ConsultantPayoutType = "ConsultantPayoutType",
  TimereportApprovedOn = "TimereportApprovedOn"
}
